import { getPbgidsByType, usePbgidIcons } from '../../helpers/pbgidIcons'
import classNames from 'classnames'
import { useSocketState } from '../../helpers/useSocket'
import { getBackendUrl } from '../../helpers/url'
import { useQuery } from 'react-query'
import { LiveGameTechDisplay } from './LiveGameTechDisplay'

export function LiveGameUniversity({ playerData, leftSide, color }) {
	const [match] = useSocketState('Match')
	const pbgidIcons = usePbgidIcons()

	const fetchCivs = async () => {
		const res = await fetch(`${getBackendUrl()}/api/config/civs`)
		return res.json()
	}

	const { data, status } = useQuery('civs', fetchCivs)

	const selectedCiv = data?.find((value) => value.aoe2cm === playerData?.civilization || value.label === playerData?.civilization)
	let playerTechs = Object.values(playerData?.technologiesResearched || []).map(String)

	return (
		<div
			className={classNames(`w-auto h-auto border-solid border flex flex-col`, leftSide ? '-ml-3' : '-mr-3')}
			style={{
				borderColor: 'var(--main-color)',
				backgroundImage: 'url("/sheepCounter/background.png")',
			}}>
			<div className={classNames('flex flex-col gap-4 px-4 py-4')}>
				{selectedCiv?.university?.map((row, rowIndex) => (
					<div key={rowIndex} className={classNames('flex flex-wrap gap-1 flex-row')}>
						{row.map((tech, i) => (
							<LiveGameTechDisplay
								key={tech?.pbgid + String(i)}
								pbg_id={tech?.pbgid}
								hasTech={playerTechs.includes(String(tech?.pbgid))}
								isUnique={tech?.isUnique || false}
							/>
						))}
					</div>
				))}
			</div>
		</div>
	)
}
